var parts = ['content', 'control', 'label'];
var baseStyleControl = {
  borderRadius: 'full',
  bg: 'white',
  borderColor: 'gray.200',
  _checked: {
    bg: 'white',
    borderColor: 'gray.200',
    color: 'brand.500',
    _before: {
      content: '""',
      display: 'inline-block',
      pos: 'relative',
      w: '80%',
      h: '80%',
      borderRadius: '50%',
      bg: 'brand.500'
    },
    _hover: {
      bg: 'white',
      borderColor: 'gray.200'
    },
    _disabled: {
      borderColor: 'gray.200',
      bg: 'gray.200',
      color: 'gray.200'
    }
  },
  _hover: {
    bg: 'white',
    color: 'white',
    borderColor: 'gray.200'
  },
  _indeterminate: {
    bg: 'brand.500',
    borderColor: 'brand.500',
    color: 'white'
  },
  _disabled: {
    bg: 'gray.100',
    borderColor: 'gray.100'
  },
  _invalid: {
    borderColor: 'red.500'
  }
};
var baseStyleLabel = {
  userSelect: 'none',
  cursor: 'pointer',
  _disabled: {
    opacity: 0.4
  },
  ml: 3
};
var baseStyle = {
  label: baseStyleLabel,
  control: baseStyleControl
};
var sizes = {
  md: {
    control: {
      w: 6,
      h: 6
    },
    label: {
      fontSize: 'md'
    }
  },
  lg: {
    control: {
      w: 8,
      h: 8
    },
    label: {
      fontSize: 'lg'
    }
  },
  sm: {
    control: {
      width: 4,
      height: 4
    },
    label: {
      fontSize: 'sm'
    }
  }
};
var defaultProps = {
  size: 'md'
};
export default {
  parts,
  baseStyle,
  sizes,
  defaultProps
};
//# sourceMappingURL=Radio.js.map